var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNextDay = function SvgNextDay(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 36,
    viewBox: "0 0 54 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1509 2H5.74196C3.67533 2 2 3.64019 2 5.66346V30.0865C2 32.1098 3.67533 33.75 5.74196 33.75H48.1509C50.2175 33.75 51.8929 32.1098 51.8929 30.0865V5.66346C51.8929 3.64019 50.2175 2 48.1509 2Z",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9454 25.2017C31.0786 25.2017 34.4293 21.9213 34.4293 17.8748C34.4293 13.8282 31.0786 10.5479 26.9454 10.5479C22.8121 10.5479 19.4614 13.8282 19.4614 17.8748C19.4614 21.9213 22.8121 25.2017 26.9454 25.2017Z",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.7692C7.51101 11.7692 11.9786 7.3954 11.9786 2",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8926 11.7692C46.3816 11.7692 41.914 7.3954 41.914 2",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 23.9798C7.51101 23.9798 11.9786 28.3536 11.9786 33.749",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8926 23.9798C46.3816 23.9798 41.914 28.3536 41.914 33.749",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNextDay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/next-day.e51a9fb9.svg";
export { ForwardRef as ReactComponent };